// extracted by mini-css-extract-plugin
export default {"homeBanner":"HomeBanner_homeBanner__mMKk9","homeBannerImg":"HomeBanner_homeBannerImg__cMevB"};